module.exports = __webpack_public_path__ + "static/media/dollar.cb3a1000.svg";